import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Button } from 'antd';

import styles from './DispexButton.module.scss';

const antButtonTypes = {
  primary: 'primary',
  default: 'default',
  dashed: 'dashed',
  danger: 'danger',
  link: 'link',
};

const DispexButton = ({
  children,
  className,
  type,
  invert,
  disabled,
  onClick,
  ...props
}) => {
  return (
    <Button
      type={antButtonTypes[type] ? type : null}
      onClick={onClick}
      disabled={disabled}
      className={classNames(className, styles.button, [styles[type]], {
        [styles.disabled]: disabled,
        [styles.invert]: invert,
      })}
      {...props}
    >
      {children}
    </Button>
  );
};

DispexButton.propTypes = {
  type: PropTypes.oneOf([
    'primary',
    'primary-dark',
    'primary-violet',
    'primary-orange',
    'secondary',
    'danger',
    'default',
    'dashed',
    'danger',
    'link',
  ]),
};

export default memo(DispexButton);
